export default {
  data() {
    return {
      showToolTip: false,
    };
  },
  methods: {
    // 检查元素是否超出最大宽度
    checkOverflow() {
      if (!this.$refs.textElement || !this.tooltipContent) {
        console.warn("CheckOverflowMixin requires 'textElement' ref and 'tooltipContent'.");
        return;
      }
      const textElement = this.$refs.textElement.$el || this.$refs.textElement;
      const containerWidth = textElement.offsetWidth;
      // 创建一个临时元素来模拟文本内容，用于测量实际宽度
      const measuringElement = document.createElement("span");
      document.body.appendChild(measuringElement);

      // 应用相同的样式确保测量准确性
      measuringElement.style.fontFamily = getComputedStyle(textElement).fontFamily;
      measuringElement.style.fontSize = getComputedStyle(textElement).fontSize;
      measuringElement.style.fontWeight = getComputedStyle(textElement).fontWeight;
      measuringElement.style.letterSpacing = getComputedStyle(textElement).letterSpacing;
      measuringElement.style.position = "absolute";
      measuringElement.style.whiteSpace = "nowrap";
      measuringElement.style.visibility = "hidden";
      measuringElement.textContent = this.tooltipContent;
      // 测量临时元素的宽度
      this.showToolTip = measuringElement.offsetWidth > containerWidth;

      // 清理DOM
      document.body.removeChild(measuringElement);
    }
  }
};